/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMembersSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListMembersRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListMembersSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListMembersSecurity$outboundSchema: z.ZodMiniType<
  ListMembersSecurity$Outbound,
  ListMembersSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMembersSecurityToJSON(
  listMembersSecurity: ListMembersSecurity,
): string {
  return JSON.stringify(
    ListMembersSecurity$outboundSchema.parse(listMembersSecurity),
  );
}

/** @internal */
export type ListMembersRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListMembersRequest$outboundSchema: z.ZodMiniType<
  ListMembersRequest$Outbound,
  ListMembersRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listMembersRequestToJSON(
  listMembersRequest: ListMembersRequest,
): string {
  return JSON.stringify(
    ListMembersRequest$outboundSchema.parse(listMembersRequest),
  );
}
